import { inPc } from "../base/bridge.js";
import { readState } from "../base/state.js";

let reservedAuthority = ["optSuper", "inPc"];

function checkValue(group, type) {
  let flag = false;
  let stateArr = [type];
  let memberInfo = readState(group) || [];
  if (memberInfo && stateArr instanceof Array) {
    (stateArr || []).forEach(st => {
      if (!flag && readState(`${group}.${st}`, "") == "1") {
        flag = true;
      }
    })
  }
  return flag;
}

export function hasPower(rules, powers, forceTrueCallback, forceFalseCallback) {
  if (!powers) {
    return true;
  }
  let forceFalse = false;
  if (forceFalseCallback) {
    powers.forEach(item => {
      if (forceFalseCallback(item)) {
        forceFalse = true;
      }
    });
  }
  if (forceFalse) {
    return false;
  }
  let currentRules = (rules || "").split("\n");
  let someFlag = powers.some((item) => {
    if (forceTrueCallback) {
      let flag = forceTrueCallback(item);
      if (flag) {
        return true;
      }
    }
    if (reservedAuthority.indexOf(item) >= 0) {
      return false;
    }
    return currentRules.some((rule) => {
      if (rule == '*') {
        return rule && true;
      }
      return rule && new RegExp(rule).test(item);
    });
  });
  return someFlag;
}

export function getPowerHandler(powers) {
  return hasPower(readState("userProfile.roleInfo.actionRules"), powers, (item) => {
    if (typeof item === 'object' && item instanceof Array) {
      return getPowerHandler(item);
    }
    if (item == "optSuper" && checkValue("userProfile", item)) {
      return true;
    }
    return false;
  }, (item) => {
    if (item == "inPc" && !inPc()) {
      return true;
    }
    return false;
  });
}